import React, { useEffect, useState } from "react";
import { filterOptions } from "../../../api/website/hotel/hotelApi";
import { Checkbox } from "@mui/joy";
import { RxStarFilled } from "react-icons/rx";
import FilterLoading from "./FilterLoading";
import { useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  setHotelFacilities,
  setHotelName,
  setMaxPrice,
  setMinPrice,
  setNeighbourhood,
  setPropertyStar,
  setRoomFacilities,
} from "../../../redux/website/search/hotelFliterSlice";
import DeleteButton from "../../../components/admin/usable/actions/DeleteButton";
const Filtering = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [FilterOptions, setFilterOptions] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const {
    propertyStar,
    hotelName,
    neighbourhood,
    hotelFacilities,
    roomFacilities,
    minPrice,
    maxPrice,
    sorting,
  } = useSelector((state) => state.hotelFilter);
  useEffect(() => {
    filterOptions(setFilterOptions, setIsLoading);
  }, []);

  // ---- Property name with debounce (reflect ~1s after typing stops) ----
  const [localName, setLocalName] = useState(hotelName || "");

  useEffect(() => {
    const t = setTimeout(() => {
      dispatch(setHotelName(localName));
    }, 1000);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localName]);

  // ---- Price range as dropdowns (min → max). Filter only when both set. ----
  const [selMin, setSelMin] = useState(minPrice || "");
  const [selMax, setSelMax] = useState(maxPrice || "");

  const priceList = Array.isArray(FilterOptions?.prices)
    ? FilterOptions.prices
    : [];

  // max options must be >= the chosen min
  const maxOptions = selMin
    ? priceList.filter((p) => Number(p) >= Number(selMin))
    : priceList;

  useEffect(() => {
    if (selMin && selMax) {
      dispatch(setMinPrice(selMin));
      dispatch(setMaxPrice(selMax));
    } else if (minPrice || maxPrice) {
      // one (or both) cleared → drop the price filter
      dispatch(setMinPrice(""));
      dispatch(setMaxPrice(""));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selMin, selMax]);

  const handlePropertyStar = (item) => {
    if (propertyStar === item) {
      dispatch(setPropertyStar(""));
    } else {
      dispatch(setPropertyStar(item));
    }
  };
  const handleHotelfacilities = (item) => {
    if (hotelFacilities.includes(item.id)) {
      dispatch(
        setHotelFacilities(hotelFacilities.filter((i) => i !== item.id)),
      );
    } else {
      dispatch(setHotelFacilities([...hotelFacilities, item.id]));
    }
  };
  const handleRoomfacilities = (item) => {
    if (roomFacilities.includes(item.id)) {
      dispatch(setRoomFacilities(roomFacilities.filter((i) => i !== item.id)));
    } else {
      dispatch(setRoomFacilities([...roomFacilities, item.id]));
    }
  };
  const handleNeighbourhood = (name) => {
    if (neighbourhood.includes(name)) {
      dispatch(setNeighbourhood(neighbourhood.filter((i) => i !== name)));
    } else {
      dispatch(setNeighbourhood([...neighbourhood, name]));
    }
  };
  const clearButton = () => {
    dispatch(setPropertyStar(""));
    dispatch(setHotelName(""));
    dispatch(setHotelFacilities([]));
    dispatch(setRoomFacilities([]));
    dispatch(setNeighbourhood([]));
    dispatch(setMinPrice(""));
    dispatch(setMaxPrice(""));
    setLocalName("");
    setSelMin("");
    setSelMax("");
  };

  return (
    <>
      {isLoading && <FilterLoading />}
      {isLoading === false && (
        <div className="w-full lg:w-[300px] h-auto overflow-y-auto space-y-5 scrollbar-hide ">
          <div className="border p-3 rounded-lg flex justify-between items-center bg-white">
            <div>
              <p className="py-2 font-bold text-sm text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
                Filter Options
              </p>
            </div>
            <div>
              {(propertyStar ||
                hotelName ||
                neighbourhood?.length > 0 ||
                hotelFacilities?.length > 0 ||
                roomFacilities?.length > 0 ||
                minPrice ||
                maxPrice ||
                sorting) && <DeleteButton onClick={clearButton} />}
            </div>
          </div>
          {/* <div className="border p-3 rounded-lg  bg-white">
            <div>
              <p className="py-2 font-bold text-sm text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
                Property Name
              </p>
            </div>
            <div>
              <input
                type="text"
                className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                placeholder="Property Name"
                value={localName}
                onChange={(e) => setLocalName(e.target.value)}
              />
            </div>
          </div> */}
          <div className="border p-3 rounded-lg bg-white">
            <div>
              <p className="py-2 font-bold text-sm text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
                Price Range
              </p>
            </div>
            <div className="grid grid-cols-2 gap-2">
              <div>
                <select
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm bg-white"
                  value={selMin}
                  onChange={(e) => {
                    const v = e.target.value;
                    setSelMin(v);
                    // if the current max is now below the new min, reset it
                    if (v && selMax && Number(selMax) < Number(v)) {
                      setSelMax("");
                    }
                  }}
                >
                  <option value="">Min Price</option>
                  {priceList.map((p, i) => (
                    <option key={`min-${i}`} value={p}>
                      {p}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <select
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm bg-white"
                  value={selMax}
                  onChange={(e) => setSelMax(e.target.value)}
                >
                  <option value="">Max Price</option>
                  {maxOptions.map((p, i) => (
                    <option key={`max-${i}`} value={p}>
                      {p}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className="border p-3 rounded-lg bg-white">
            <div>
              <p className="py-2 font-bold text-sm text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
                Property Star
              </p>
            </div>
            <div className="flex justify-start items-center gap-2">
              {Array.from({ length: 5 }).map((_, index) => {
                const isSelected = propertyStar === index + 1;
                return (
                  <div key={index}>
                    <div
                      onClick={() => handlePropertyStar(index + 1)}
                      className={`flex justify-start items-center gap-1 select-none ${
                        isSelected
                          ? "bg-blue-900  text-white"
                          : "bg-blue-200 text-blue-500"
                      }  p-1 rounded-md text-xs font-bold cursor-pointer`}
                    >
                      <RxStarFilled className="" />
                      {index + 1}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          {FilterOptions?.hotelFacilities?.length > 0 && (
            <div className="border p-3 rounded-lg bg-white">
              <div>
                <p className="py-2 font-bold text-sm text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
                  Hotel Facilities
                </p>
              </div>
              {FilterOptions?.hotelFacilities?.map((item, index) => {
                return (
                  <div onClick={() => handleHotelfacilities(item)} key={index}>
                    <Checkbox
                      checked={hotelFacilities.includes(item.id)}
                      label={item.facilityName}
                      size="sm"
                    />
                  </div>
                );
              })}
            </div>
          )}
          {FilterOptions?.roomFacilities?.length > 0 && (
            <div className="border p-3 rounded-lg bg-white">
              <div>
                <p className="py-2 font-bold text-sm text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
                  Room Amenties
                </p>
              </div>
              {FilterOptions?.roomFacilities?.map((item, index) => {
                return (
                  <div onClick={() => handleRoomfacilities(item)} key={index}>
                    <Checkbox
                      checked={roomFacilities.includes(item.id)}
                      label={item.facilityName}
                      size="sm"
                    />
                  </div>
                );
              })}
            </div>
          )}
          {FilterOptions?.neighborhood?.length > 0 && (
            <div className="border p-3 rounded-lg bg-white">
              <div>
                <p className="py-2 font-bold text-sm text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
                  Neighborhood
                </p>
              </div>
              {FilterOptions?.neighborhood.map((item, index) => {
                return (
                  <div
                    onClick={() => handleNeighbourhood(item.neighbourhoodName)}
                    key={index}
                  >
                    <Checkbox
                      checked={neighbourhood.includes(item.neighbourhoodName)}
                      label={item.neighbourhoodName}
                      size="sm"
                    />
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Filtering;
